import React from "react";
import PropTypes from "prop-types";
import TextProps from "../../Text/Text.types";
import * as S from "./FormErrorText.styles";

/**
 * BW FormErrorText component.
 */
const FormErrorText: React.FC<TextProps> = ({ children, ...rest }) => (
    <S.StyledErrorMessage variant="p" {...rest}>
        {children}
    </S.StyledErrorMessage>
);

FormErrorText.propTypes = {
    children: PropTypes.string.isRequired
};

export default FormErrorText;
